import { render } from "./AddToCartModal.vue?vue&type=template&id=1f0860c9&scoped=true&bindings={}"
import script from "./AddToCartModal.vue?vue&type=script&lang=ts"
export * from "./AddToCartModal.vue?vue&type=script&lang=ts"

import "./AddToCartModal.vue?vue&type=style&index=0&id=1f0860c9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1f0860c9"

export default script